module.exports = __webpack_public_path__ + "resources/img/bg_banner_inquiry_v2.8f1bf3e14139213ef82141ea94b26d93.png";